import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const handle401Error = async () => {
  console.log("handle401Error called!");
  // Rest of your middleware logic
};

export const pricingApi = createApi({
  reducerPath: "pricingApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(handle401Error),
  endpoints: (builder) => ({
    subscription: builder.mutation({
      query: (payload) => ({
        url: "payments/subscribe",
        method: "POST",
        body: payload,
      }),
    }),
    confirmSubscription: builder.mutation({
      query: (payload) => ({
        url: "payments/subscription/confirm",
        method: "POST",
        body: payload,
      }),
    }),
    cancelSubscription: builder.mutation({
      query: () => ({
        url: "payments/subscription/cancel",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useSubscriptionMutation,
  useConfirmSubscriptionMutation,
  useCancelSubscriptionMutation,
} = pricingApi;
